import Spinner from 'react-bootstrap/Spinner';

export const LoadingSpinner = () => {
    return (
        <Spinner
            as='span'
            animation='border'
            role='status'
            size='sm'
        >
            <span className='visually-hidden'>Loading...</span>
        </Spinner>
    )
}